// packages/content/src/tuning/yields.ts
import type { TuningBank } from '../schema/tuning';
export default { digSpotsPerDay: 4, shellsPerDay: 5 } as const satisfies TuningBank;
